<template>
<div class="wdrClaim">
    <div v-if="claimob.wait">ожидайте...</div>
    <div v-if="!claimob.wait && claimob.message">{{claimob.message}}</div>
    <div v-if="!claimob.wait && !claimob.message">
        <template v-if="isActive(claimob.status)">
            <div class="wdrClaimT">Вознаграждение</div>
            <div class="wdrClaimOk">
                <RewardIcon />
                <span>заявка на выплату <b>{{claimob.reward.sum}}</b>р создана</span>
                <a :href="props.link" target="_blank">статус выплаты, документы</a>
            </div>
        </template>
        <template v-else-if="isBefore(claimob.status)">
            <div class="wdrClaimT">Вознаграждение</div>
            <div class="wdrClaimOk">
                <RewardIcon />
                <span>доступно <b>{{claimob.reward.sum}}р</b></span>

                <div v-if="claimob.status.whynot" v-html="claimob.status.whynot"></div>
                <div v-else>{{claimob.status.name}}</div>

            </div>
        </template>
        <template v-else-if="isShould(claimob.status) || isReady(claimob.status)">
            <div class="wdrClaimT">Вознаграждение</div>
            <div class="wdrClaimOk">
                <RewardIcon />
                <span>доступно <b>{{claimob.reward.sum}}р</b></span>
                <a v-if="claimob.access.allow" :href="props.link" target="_blank">получить</a>
            </div>
            <div class="wdrClaim__Not"
                v-if="!claimob.access.allow" 
                v-text="claimob.access.whynot"></div>
        </template>
        <template v-else></template>
    </div>
</div>
</template>

<style lang="scss">
.wdrClaim {
    background: #fff; 
    border-radius: 5px; 
    padding-bottom: 10px; 
    padding-top: 5px;
    &__Not {
        color:#aa0000;
    }
}
.wdrClaimT {font-size: 22px; font-weight: bold; margin: 10px 0 10px 10px;}
.wdrClaimOk {
    display: flex; margin-left: 5px;
    align-items: center;    
    --icon-color: #008000;
    --icon-size: 30px;
}
.wdrClaimOk > * { margin: 3px 5px;  }
.wdrClaimOth {display: flex; margin-left: 5px;}
.wdrClaimOth > * { margin: 3px 5px;  }
</style>

<script setup>
import {ref, unref, computed, onMounted, reactive} from 'vue'    
import { numWord } from '@/util.js'
import {isBefore, isShould, isReady, isActive} from '@/payout/util.js'
import {getWithdrawalSummary} from '@/actions.js'

import RewardIcon from '@/assets/vicons/payout.vue'

import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)

const props = defineProps({
    claim_num: String, 
    link: String,
})

const now = ref(null)


const claimob = reactive({
  claim : null,
  status: null,
  reward: null,
  actreward: null,
  access: null,
  wait: true,
  message: '',
})

const load = () => {
    claimob.claim = null
    claimob.wait = true
    claimob.message = ''
    const {claim_num} = props

    now.value = new Date

    getWithdrawalSummary({
        claim_num, //actreward:true
    }).then((
        {claim, status,  reward, access,}
    ) => {
      claimob.wait = false
      Object.assign( claimob, { claim, status, reward, access} )
    }, message => {
      claimob.wait = false
      claimob.message = `Не удалось получить информацию по заявке ${claim_num}: ${message}`
    } )
}

// Смотри кнопка для фт через 10 дней после даты окончания. Для юрлиц - 2 день после начала тура
const days_left = computed(() => {
    let ret = -1
    let word = ''
    if (!claimob.wait && !claimob.message ) {
        const claim =  claimob.claim
        let happydate
        if (claim.is_agent_freelance) {
            happydate = dayjs(claimob.claim.dateend).add(10,'days')
        } else {
            happydate = dayjs(claimob.claim.datebeg).add(2,'days')
        }
//console.log('happydate', happydate)
        ret = dayjs.duration(happydate.diff(now.value)).asDays()
        ret = Math.floor( ret )
        word = numWord(ret, ['день', 'дня', 'дней'])
    }
    return {num: ret, word}
})

onMounted(load)

</script>
